import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { LandingActionKey } from 'partner360/models/landing/LandingActionKey'

import { requestInitPlan } from '../api/requestInitPlan'
import { requestLandingData } from '../api/requestLandingData'
import { changePartnersForInitPlans, changePlanInitStatus } from '../landingSlice'
import { addLandingPartner } from '../landingSlice'
import { selectInitPlanFinished } from '../selectors/selectInitPlanFinished'

listenerMiddleware.startListening({
  actionCreator: requestLandingData.fulfilled,
  effect: async (action, { dispatch, getState }) => {
    if (action.payload) {
      const { processedPlannings, plannings } = action.payload

      const isInitPlanFinished = selectInitPlanFinished(getState())

      const allFiltered = processedPlannings.filter((el) =>
        el.actions.find((el) => el.Key === LandingActionKey.InitPlan)
      )

      const uniqAllPartnerIds = Array.from(new Set(allFiltered.map((el) => el.partnerId)))

      if (!isInitPlanFinished && uniqAllPartnerIds.length > 0) {
        dispatch(changePlanInitStatus(RequestStatus.PENDING))
        dispatch(changePartnersForInitPlans(uniqAllPartnerIds.length))

        for (const planning of plannings) {
          const filteredByPlanning = allFiltered.filter(
            (el) => el.planningId === planning.PlanningId
          )
          const uniqPartnerIdsByPlanning = Array.from(
            new Set(filteredByPlanning.map((el) => el.partnerId))
          )

          if (uniqPartnerIdsByPlanning.length) {
            for (const partnerId of uniqPartnerIdsByPlanning) {
              await dispatch(requestInitPlan({ partnerId, fYear: planning.FYear }))
            }
          }
        }

        dispatch(changePlanInitStatus(RequestStatus.FULFILLED))
        await dispatch(requestLandingData())
      }
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: addLandingPartner,
  effect: (_, { dispatch }) => {
    dispatch(requestLandingData({ isRefreshing: true }))
  },
})
